import React from 'react';

import { Form } from 'semantic-ui-react';

interface PagoDepositoProps {
    numeroDeDeposito: string;
    alCambiarCampo(nombreDelCampo: string, valor: string | boolean): void;
}
// TODO: instituciones agregadas a mano. Hay que sacarlas del mismo lado de matriculas
// TODO: exigir que estén todos los datos del cheque para poder ingresar pago

const PagoDeposito: React.FunctionComponent<PagoDepositoProps> = props => {
    const { numeroDeDeposito, alCambiarCampo } = props;

    return (
        <div>
            <Form.Input
                label='Numero de depósito'
                placeholder='123456'
                value={numeroDeDeposito}
                width={6}
                onChange={(_e, { value }) => {
                    alCambiarCampo('numeroDeDeposito', value);
                }}
            />
        </div>
    );
};

export default PagoDeposito;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/PagoDeposito.tsx